// Dependencies
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
// Components
import Header from '../components/Header/header';
import jquery from 'jquery';

// Components
import WhiteSpace from '../components/WhiteSpace/whiteSpace';
import QuickAbout from '../components/About/quickAbout';
import Promotions from '../components/Promotions/promotions';
import Carousel from '../components/Sliders/carousel';

global.jQuery = jquery;
global.$ = jquery;

class Inicio extends Component {
   productsSection = React.createRef(null);

   goToProductsSection = () => {
      this.productsSection.current.scrollIntoView({ behavior: 'smooth' });
   };

   componentDidMount() {
      const element = document.getElementsByClassName('color-selected');
      if (element.length > 0) {
         element[0].classList.remove('color-selected');
      }
   }

   render() {
      return (
         <div className="inicio">
            <Helmet>
               <title>INICIO - Expo Médica </title>
            </Helmet>
            <Header inicio={false}></Header>
            <Carousel goToProductsSection={this.goToProductsSection}></Carousel>
            <WhiteSpace height="48" />
            <Promotions refProp={this.productsSection}></Promotions>
            <WhiteSpace height="32" />
            <QuickAbout></QuickAbout>
            <WhiteSpace height="48" />
         </div>
      );
   }
}

export default Inicio;



// WEBPACK FOOTER //
// ./src/pages/inicio.js